import React from 'react';

import Money from 'components/Money';

import './styles.css';

const Totals = ({creditNote}) => {
  return (
    <div className="Totals">
      <div className="section">
        <div className="header">Subtotal</div>
        <div className="value">
          <Money amount={creditNote.totalExcludingTax} />
        </div>
      </div>
      <div className="section">
        <div className="header">Total Vat</div>
        <div className="value">
          <Money
            amount={creditNote.totalIncludingTax - creditNote.totalExcludingTax}
          />
        </div>
      </div>
      <div className="section">
        <div className="header">Total Credit</div>
        <div className="value">
          <Money amount={creditNote.totalIncludingTax} />
        </div>
      </div>
    </div>
  );
};

export default Totals;
